import NumberOfForms from '../../../../components/editable-cell/form-items/number-of-forms'
import { hasTaskOfType } from '../../helpers/has-task-of-type'
import { onCellStandard } from '../../helpers/helpers'
import type { ShipmentColumn } from '../../types/column-types'

export const numberOfFormsColumn: ShipmentColumn = {
    key: 'numberOfForms',
    dataIndex: 'numberOfForms',
    title: (
        <>
            Кол-во <br />
            форм
        </>
    ),
    width: 50,
    editable: true,
    FormItem: <NumberOfForms />,
    onCell: (record, index) => ({
        ...onCellStandard(record, index),
        editable: !hasTaskOfType(record, 'Заказ форм')
    }) as any,
}
